import { SelectedProductDTO } from "@models/platform-analysis/entities/steps/feature";
import { AnalysisSummaryDTO } from "@models/platform-analysis/entities/steps/summary";
import { TableViewMode } from "@models/platform-analysis/enums/tableViewMode";
import { summaryFeatureAnalysisDisqualifiedTableRowsSelectorsByIndex } from "@redux/slices/platform-analysis";
import { RootState } from "@redux/store";
import { isEqual } from "lodash";
import { memo, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { SummaryAnalysisTable } from "../../features/table-components/container";

export const AppendixFeatureAnalysisTable = memo(
  ({
    index,
    selectedProducts,
  }: {
    index: number;
    selectedProducts: SelectedProductDTO[];
  }) => {
    const { control } = useFormContext<AnalysisSummaryDTO>();

    const viewMode = useWatch({
      control,
      name: "featureAnalysisTableViewMode",
    });
    const storedShowAnalysisScore = useSelector(
      (state: RootState) => state.platformAnalysis.ui.isShowAnalysisScores,
    );
    const storedTableRows = useSelector(
      summaryFeatureAnalysisDisqualifiedTableRowsSelectorsByIndex(index)
        .selectAll,
    );

    const isDetailViewMode = useMemo(
      () => isEqual(viewMode, TableViewMode.Detail),
      [viewMode],
    );

    return (
      <SummaryAnalysisTable
        isReview={true}
        rows={storedTableRows}
        selectedProducts={selectedProducts}
        wrapperProps={{
          isAppendix: true,
          noSelectionColumn: isDetailViewMode,
          showAnalysisScore: storedShowAnalysisScore,
          viewMode: viewMode,
        }}
      />
    );
  },
);
